import { Outlet, createFileRoute } from "@tanstack/react-router";
import ContainerInset from "@/components/container-inset.tsx";
import { useMerchantProvider } from "@/app/(authenticated)/_providers/merchant-provider.tsx";

export const Route = createFileRoute(
  "/(authenticated)/$merchantId/customers/$id"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { selectedMerchant } = useMerchantProvider();

  const breadcrumbs = [
    {
      title: "Customers",
      href: `/${selectedMerchant?.merchAccountId}/customers`,
    },
    {
      title: "Customer Details",
      href: "#",
    },
  ];

  return (
    <ContainerInset breadcrumbs={breadcrumbs}>
      <Outlet />
    </ContainerInset>
  );
}
